class Utils{

    containsSection(list,object){
        return this.contains(list,object);
    }

    containsContext(list,object){
        return this.contains(list,object);
    }

    containsCard(list,object){
        return this.contains(list,object);
    }

    containsProduct(list,object){
        return this.contains(list,object);
    }

    contains(list,object){
        var contains = false;
        for(var i=0; i<list.length; i++){
            if(list[i].id == object.id){
                contains = true;
                break;
            }
        }
        return contains;
    }

}

export default new Utils();